import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import ItemSmall from './ItemSmall';
import ManageToppingGroup from './ManageToppingGroup';
import ManageTopping from './ManageTopping';
import ReactModal from './ReactModal';
import { COLORS } from '../utils/colors';

const SmallListToppings = (props) => {
  const { toppings, toppingGroups, visible } = props;
  const [toppingGroupModalIsOpen, setToppingGroupModalIsOpen] = useState(false);
  const [toppingModalIsOpen, setToppingModalIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const handleToppingGroupClick = (toppingGroup) => {
    setActiveItem(toppingGroup);
    setToppingGroupModalIsOpen(true);
  };

  const handleToppingClick = (topping) => {
    setActiveItem(topping);
    setToppingModalIsOpen(true);
  };

  if (!visible) return null;

  return (
    <div>
      {toppingGroups.length > 0 && (
        <>
          <Grid item xs={12}>
            <p
              style={{
                fontSize: '0.8rem',
                fontWeight: 'bold',
                color: COLORS.INFO,
                textAlign: 'center',
                marginBottom: '32px',
              }}
            >
              TOPPING GROUPS
            </p>
          </Grid>
          <Grid container spacing={2} item xs={12}>
            {toppingGroups.map((toppingGroup) => {
              return (
                <Grid key={toppingGroup.id} item xs={12} sm={12} md={6}>
                  <ItemSmall
                    item={toppingGroup}
                    position={undefined}
                    action={() => handleToppingGroupClick(toppingGroup)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
      {toppings.length > 0 && (
        <>
          <Grid item xs={12}>
            <p
              style={{
                fontSize: '0.8rem',
                fontWeight: 'bold',
                color: COLORS.INFO,
                textAlign: 'center',
                margin: '32px 0',
              }}
            >
              TOPPINGS
            </p>
          </Grid>
          <Grid container spacing={2} item xs={12}>
            {toppings.map((topping) => {
              return (
                <Grid key={topping.id} item xs={12} sm={12} md={6}>
                  <ItemSmall
                    item={topping}
                    position={topping.position}
                    action={() => handleToppingClick(topping)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </>
      )}

      {toppings.length === 0 && toppingGroups.length === 0 && (
        <Grid item xs={12}>
          <p
            style={{
              fontSize: '0.8rem',
              fontWeight: 'bold',
              color: COLORS.INFO,
              textAlign: 'center',
              marginBottom: '32px',
            }}
          >
            Nothing found!
          </p>
        </Grid>
      )}

      {toppingGroupModalIsOpen && (
        <ReactModal modalIsOpen={toppingGroupModalIsOpen} setIsOpen={setToppingGroupModalIsOpen}>
          <ManageToppingGroup
            type="edit"
            toppingGroupId={activeItem.id}
            onClose={() => setToppingGroupModalIsOpen(false)}
          />
        </ReactModal>
      )}

      {toppingModalIsOpen && (
        <ReactModal modalIsOpen={toppingModalIsOpen} setIsOpen={setToppingModalIsOpen}>
          <ManageTopping
            type="edit"
            toppingId={activeItem.id}
            toppingGroupId={activeItem.toppings_group_id}
            onClose={() => setToppingModalIsOpen(false)}
          />
        </ReactModal>
      )}
    </div>
  );
};

export default SmallListToppings;
